import { AjaxRequestOptions } from '@amzn/aac-chrome-internal-api';
import { composeMetricSlug } from 'src/commons/utils/async-request';
import logError from 'src/commons/utils/async-request/log-error';
import { AjaxRequestPublisher } from 'src/commons/utils/metrics';

const ChromeInternalApiRequestConfig: AjaxRequestOptions = {
  emitLatencyMetric: ({ endpoint, latency, method }) => {
    const { latencyMetricSlug } = composeMetricSlug({
      endpoint,
      method,
    });
    AjaxRequestPublisher.publishTimerMonitor(latencyMetricSlug, latency);
  },
  emitSuccessMetric: ({ endpoint, isSuccess, method }) => {
    const { successMetricSlug } = composeMetricSlug({
      endpoint,
      method,
    });
    AjaxRequestPublisher.publishCounterMonitor(
      successMetricSlug,
      isSuccess === true ? 1 : 0,
    );
  },
  // `kind` and `status` are forwarded so these endpoints (navbar-init,
  // accountswitcher-init, navState, chromeData) get the classified counters.
  // An older global InternalAPI sends neither, and log-error then falls back
  // to its message regexes.
  logError: ({ endpoint, error, method, kind, status }) => {
    const { sanitizedUrl, metricSlug } = composeMetricSlug({
      endpoint,
      method,
    });
    logError({
      error,
      loggerMessage: `Failed ${method} request to '${sanitizedUrl}'`,
      metricSlug,
      ...(kind !== undefined ? { kind } : {}),
      ...(status !== undefined ? { status } : {}),
    });
  },
};

export default ChromeInternalApiRequestConfig;
